var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"color":"primary"}},'v-btn',_vm.$attrs,false),_vm.inputListeners),[_vm._t("default"),_vm._v(" "+_vm._s(_vm.$attrs.title)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }